import { Controller } from "@hotwired/stimulus"

const COLLAPSED_KEY = "bo-sidebar-collapsed"

export default class extends Controller {
  connect() {
    if (localStorage.getItem(COLLAPSED_KEY) === "1") {
      document.body.classList.add("sidebar-desktop-collapsed")
    }
  }

  toggle() {
    if (window.innerWidth >= 1024) {
      const collapsed = document.body.classList.toggle("sidebar-desktop-collapsed")
      localStorage.setItem(COLLAPSED_KEY, collapsed ? "1" : "0")
    } else {
      document.body.classList.toggle("sidebar-mobile-open")
    }
  }

  close() {
    document.body.classList.remove("sidebar-mobile-open")
  }
}
